module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-tile-2-large-6a8cd3da98960eb582fb888c929446f2.jpg";